import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method apiGetPointHistory
 * @method apiExpirePoint
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} token
     * @param {Object} params HistoryPointConfigModel - /service/config/PointConfigModel.js
     */
    apiGetPointHistory: function(token, params) {
        var url = this.config().bzbsUrl + "/log/points";
        return BzbsApi.connectBzbsGet(url, token, params);
    },

    /**
     * @param {string} token
     */
    apiExpirePoint: function(token) {
        var url = this.config().bzbsUrl + "/log/points";
        return BzbsApi.connectBzbsGet(url, token, null);
    }
}
